export const LOCAL_DELIVERY_THRESHOLD = 60;
export const LOCAL_DELIVERY_FEE = 9.99;
export const LOCAL_DELIVERY_RATE_ID = 'local-delivery';

/** Default pickup location label shown in the checkout and order flows. */
export const DEFAULT_PICKUP_LOCATION = 'Ottawa Store (114, 15 Capella Ct, ON, Canada)';

/** Pickup location options shared across checkout and profile preferences. */
export const PICKUP_OPTIONS = [
  { value: DEFAULT_PICKUP_LOCATION, label: DEFAULT_PICKUP_LOCATION },
  { value: 'Ottawa Warehouse (114, 15 Capella Ct, ON)', label: 'Ottawa Warehouse (114, 15 Capella Ct, ON)' },
];

/** Canadian province list used in address forms. */
export const CA_PROVINCES = [
  { code: 'AB', name: 'Alberta' },
  { code: 'BC', name: 'British Columbia' },
  { code: 'MB', name: 'Manitoba' },
  { code: 'NB', name: 'New Brunswick' },
  { code: 'NL', name: 'Newfoundland and Labrador' },
  { code: 'NS', name: 'Nova Scotia' },
  { code: 'NT', name: 'Northwest Territories' },
  { code: 'NU', name: 'Nunavut' },
  { code: 'ON', name: 'Ontario' },
  { code: 'PE', name: 'Prince Edward Island' },
  { code: 'QC', name: 'Quebec' },
  { code: 'SK', name: 'Saskatchewan' },
  { code: 'YT', name: 'Yukon' },
];

const OTTAWA_CITIES = [
  'ottawa',
  'nepean',
  'kanata',
  'orleans',
  'gloucester',
  'stittsville',
  'manotick',
  'barhaven',
  'greely',
  'carp',
  'munster',
  'kemptville',
];

const GATINEAU_CITIES = [
  'gatineau',
  'hull',
  'aylmer',
  'buckingham',
  'masson-angers',
  'masson angers',
  'cantley',
  'chelsea',
  'la peche',
  'lapeche',
];

const OTTAWA_POSTAL_PREFIXES = ['K'];
const GATINEAU_POSTAL_PREFIXES = ['J8', 'J9'];

const normalize = (value) => String(value || '').trim().toLowerCase();

const normalizePostal = (value) =>
  String(value || '').replace(/\s+/g, '').toUpperCase();

export const isLocalDeliveryAddress = (address = {}) => {
  const country = normalize(address.country);
  if (country && country !== 'ca' && country !== 'canada') return false;

  const province = normalize(address.province || address.state);
  if (
    province &&
    province !== 'on' &&
    province !== 'ontario' &&
    province !== 'qc' &&
    province !== 'quebec'
  )
    return false;

  const city = normalize(address.city);
  const postal = normalizePostal(address.postalCode);
  const isOttawaPostal = OTTAWA_POSTAL_PREFIXES.some((prefix) =>
    postal.startsWith(prefix)
  );
  const isGatineauPostal = GATINEAU_POSTAL_PREFIXES.some((prefix) =>
    postal.startsWith(prefix)
  );
  const isOttawaCity = OTTAWA_CITIES.some((name) => city.includes(name));
  const isGatineauCity = GATINEAU_CITIES.some((name) => city.includes(name));

  if (city) {
    return isOttawaCity || isGatineauCity;
  }

  if (!postal) return false;
  return isOttawaPostal || isGatineauPostal;
};

export const getLocalDeliveryRate = (itemsSubtotal = 0) =>
  Number(itemsSubtotal) >= LOCAL_DELIVERY_THRESHOLD
    ? 0
    : LOCAL_DELIVERY_FEE;
